import React from 'react';
import { useLoaderData } from 'react-router-dom';
import Question from '../../QuestionCard/Question';

const QuizQuestions = () => {
    const loadQuestions = useLoaderData().data;
    console.log(loadQuestions);
    const { total, id, name, questions } = loadQuestions;
    return (
        <div className='text-xl'>
            <div>

                <h1 className='font-bold text-3xl mb-5'> Questions of {name} Quiz</h1>
                <h2>We Have Total {total} questions</h2>

            </div>
            <div>
                {
                    questions.map(EachQuestion =>
                        <Question
                            key={EachQuestion.id}
                            EachQuestion={EachQuestion}>

                        </Question>)
                }


            </div>
        </div>
    );
};

export default QuizQuestions;